module.exports = __webpack_public_path__ + "img/eric_rowe.238fde02.png";